import MyTitle from "../../components/MyTitle";

const Term = () => {
  return (
    <div className="privacy-content">
      {/* Start */}
      <MyTitle title="제 1장 총칙" className="mb-4" />

      <h5 className="font-semibold mb-4">제 1조 (목적과 정의)</h5>

      <p className="mb-4">
        통합서비스약관은 K-CDH가 운영하는 다양한 서비스 (이하 “통합 서비스” 또는
        “서비스”)를 이용하실 수 있도록 통합서비스 약관 (이하 “본 약관”)을
        제정하여 회원과 통합 서비스의 권리, 의무 및 책임사항을 규정함을 목적으로
        합니다. 회원은 본 약관에 동의함으로써 통합서비스에 가입하여 통합서비스를
        이용할 수 있습니다. 본 약관은 회원이 통합서비스를 이용하는데 필요한
        절차, 권리, 의무 및 이용조건과 절차 등 기본적인 내용을 포함하고 있으므로
        주의 깊게 보아주십시오.
      </p>

      <ul className="list-disc pl-8 flex flex-col gap-3 mb-4">
        <li>
          <p>
            “회원” 이란 통합서비스에 접속하여 본 약관에 따라 통합서비스 회원으로
            가입하여 통합서비스가 제공하는 서비스를 받는 자를 말합니다.
          </p>
        </li>
        <li>
          <p>
            “개인정보”란 당해 정보에 포함되어 있는 성명, 생년월일, 성별, 이메일
            등의 사항에 의하여 특정 개인을 식별할 수 있는 정보(당해 정보만으로는
            특정 개인을 인식할 수 없더라도 다른 정보와 용이하게 결합하여 식별할
            수 있는 것을 포함)를 말합니다.
          </p>
        </li>
      </ul>

      <h5 className="font-semibold mb-4">제 2조 (약관의 효력 및 변경)</h5>

      <ul className="list-decimal pl-8 flex flex-col gap-3 mb-10">
        <li>
          <p>
            본 약관의 내용은 K-CDH 사이트(www.k-cdh.org) 또는 개별 서비스의
            화면에 게시하거나 기타의 방법으로 공지하고, 본 약관에 동의한 회원
            모두에게 그 효력이 발생합니다.
          </p>
        </li>
        <li>
          <p>
            K-CDH는 필요한 경우 관련법령을 위배하지 않는 범위 내에서 본 약관을
            변경할 수 있습니다. 본 약관이 변경되는 경우 K-CDH는 변경사항을
            시행일자 7일 전부터 서비스 공지사항에서 공지하는 것을 원칙으로
            합니다.
          </p>
        </li>
        <li>
          <p>
            K-CDH가 전항에 따라 공지를 하면서 공지일로부터 개정약관 시행일 7일
            이후까지 부동의 의사를 표현하지 않는 한, 변경된 약관에 동의하는
            것으로 간주 합니다. 회원이 개정약관에 동의하지 않을 경우 회원은
            이용계약을 해지할 수 있으며, K-CDH는 서비스 제공을 중지할 수
            있습니다.
          </p>
        </li>
      </ul>

      <MyTitle title="제 2장 통합서비스 이용 계약" className="mb-4" />

      <h5 className="font-semibold mb-4">제 3조 (이용 계약의 체결)</h5>

      <ul className="list-decimal pl-8 flex flex-col gap-3 mb-10">
        <li>
          <p>
            통합서비스 이용 계약은 회원이 본 약관의 내용에 동의한 후 서비스에서
            정한 가입 양식에 따라 회원 개인 정보를 기입하고 승낙함으로써
            체결됩니다.
          </p>
        </li>
      </ul>

      <MyTitle title="제 3장 통합서비스 이용" className="mb-4" />

      <h5 className="font-semibold mb-4">제 4조 (서비스의 제공)</h5>

      <ul className="list-decimal pl-8 flex flex-col gap-3 mb-4">
        <li>
          <p>
            통합서비스 이용계약이 성립되면 회원은 통합서비스를 구성하는 개별
            서비스를 이용할 수 있고 개별 서비스별로 별도의 이용계약을 체결하지는
            않습니다.
          </p>
        </li>
        <li>
          <p>
            다만 통합서비스 내에서 일부 하위 서비스의 경우 별도의 이용약관에
            동의해야 이용 가능하며 필요한 추가 정보를 기재하거나 별도의 인증
            절차를 요구할 수도 있습니다. 별도의 이용약관에 동의하는 경우,
            통합서비스 이용약관을 우선으로 해석합니다.
          </p>
        </li>
        <li>
          <p>
            통합서비스 이용 중 시스템 오류 등 문제점을 발견한다면 고객문의
            이메일 (이메일 주소)을 이용하여 알려주십시오.
          </p>
        </li>
      </ul>

      <h5 className="font-semibold mb-4">제 5조 (서비스의 변경 및 중단)</h5>

      <ul className="list-decimal pl-8 flex flex-col gap-3 mb-4">
        <li>
          <p className="mb-2">
            K-CDH는 통합서비스를 365일, 24시간 제공하기 위하여 최선의 노력을 다
            합니다. 다만 아래 각 호의 경우 통합서비스의 전부 또는 일부를
            제한하거나 중지할 수 있습니다.
          </p>

          <ul className="list-decimal pl-8 flex flex-col gap-2">
            <li>
              <p className="text-gray-dark">
                통합서비스 설비의 유지보수 및 점검을 위한 정기 또는 임시점검의
                경우
              </p>
            </li>
            <li>
              <p className="text-gray-dark">
                통합서비스를 제공하는 컴퓨터 등 정보통신설비의 보수점검·교체 및
                고장, 통신의 두절 , 이용량의 폭주 등으로 정상적인 통합서비스
                이용에 지장이 있는 경우
              </p>
            </li>
            <li>
              <p className="text-gray-dark">
                새로운 서비스로의 교체 혹은 기타 통합서비스에서 필요하다고
                판단하는 경우
              </p>
            </li>
            <li>
              <p className="text-gray-dark">
                기타 천재지변, 국가비상사태 등 불가항력적 사유가 발생한 경우
              </p>
            </li>
          </ul>
        </li>
        <li>
          <p>
            전항에 의한 통합서비스가 중단 또는 변경될 경우 해당 내용 및
            제공일자를 제 8조 제2항에 정한 서비스의 공지를 통하여 전달할 수
            있습니다. 다만 K-CDH으로서도 예측할 수 없거나 통제할 수 없는 사유
            (K-CDH의 과실이 아닌 디스크 또는 서버 장애, 시스템 다운 등)로 사전
            통지나 공지가 불가능한 경우에는 그러지 아니합니다. 이러한 경우라도
            K-CDH가 상황을 파악하는 즉시 조치하여 최대한 빠른 시일 내에 서비스를
            복구하도록 노력하겠습니다.
          </p>
        </li>
        <li>
          <p>
            K-CDH는 통합서비스의 전부, 일부 사용 제한 또는 중지에 따른 회원의
            피해에 대해서는 책임을 지지 아니합니다.
          </p>
        </li>
      </ul>

      <h5 className="font-semibold mb-4">제 6조 (회원 탈퇴)</h5>

      <ul className="list-decimal pl-8 flex flex-col gap-3 mb-4">
        <li>
          <p>
            통합서비스 이용계약 해지를 원하는 경우 회원은 언제든지 서비스 내
            제공되는 메뉴를 통해 해지 신청을 할 수 있습니다. 통합서비스는 회원의
            해지 요청을 받은 즉시 해당 회원의 회원 등록 말소를 위한 절차를
            밟습니다.
          </p>
        </li>
        <li>
          <p>
            통합서비스 이용계약이 해지되면 관련 법령 및 K-CDH 개인정보
            처리방침에 따라 회원의 일정 정보를 보유하는 경우를 제외하고 회원의
            정보를 삭제합니다. 단, 회원이 통합서비스의 하위 서비스를 이용하면서
            별도의 제공 동의 절차를 거치고 K-CDH에 제공한 일부 정보의 경우,
            삭제되지 않고 K-CDH에 남아있게 됩니다. 특히 K-CDH가 제공하는 서비스
            가입을 위해 필수적으로 기입되어야 하는 정보의 경우, 회원은 탈퇴 및
            이용계약 해지를 이유로 그 삭제나 파기를 주장할 수 없습니다.
          </p>
        </li>
      </ul>

      <h5 className="font-semibold mb-4">
        제 7조 (회원 사용 제한, 자격 상실, 공개 게시물의 삭제)
      </h5>

      <ul className="list-decimal pl-8 flex flex-col gap-3 mb-4">
        <li>
          <p className="mb-2">
            회원이 다음 각 호의 사유에 해당하는 경우, 통합서비스는 사전통지 없이
            회원자격을 적절한 방법으로 제한 및 정지, 상실시킬 수 있습니다.
          </p>

          <ul className="list-decimal pl-8 flex flex-col gap-2">
            <li>
              <p className="text-gray-dark">
                회원가입신청 또는 변경 시 허위내용을 등록하는 행위
              </p>
            </li>
            <li>
              <p className="text-gray-dark">
                통합서비스 및 기타 제3자의 인격권 또는 지식재산권을 침해하거나
                업무를 방해하는 행위
              </p>
            </li>
            <li>
              <p className="text-gray-dark">다른 회원의 ID를 도용하는 행위</p>
            </li>
            <li>
              <p className="text-gray-dark">
                광고 또는 외설, 폭력적인 메시지·화상·음성 등이 담긴 메일을
                보내는 등 기타 공서양속에 반하는 정보를 공개 또는 게시하는 행위.
              </p>
            </li>
            <li>
              <p className="text-gray-dark">
                관련 법령에 의하여 그 전송 또는 게시가 금지되는 정보(컴퓨터
                프로그램 등)의 전송 또는 게시하는 행위.
              </p>
            </li>
            <li>
              <p className="text-gray-dark">
                통합서비스 직원이나 서비스 관리자를 가장 혹은 사칭하거나 타인의
                명의를 도용하여 글을 게시하거나 메일을 발송하는 행위.
              </p>
            </li>
            <li>
              <p className="text-gray-dark">
                컴퓨터 소프트웨어, 하드웨어, 전기통신 장비의 정상적인 가동을
                방해, 파괴할 목적으로 고안된 소프트웨어 바이러스, 기타 다른
                컴퓨터 코드, 파일, 프로그램을 포함하고 있는 자료를 게시하거나
                전자우편으로 발송하는 행위.
              </p>
            </li>
            <li>
              <p className="text-gray-dark">
                스토킹(stalking) 등 다른 회원을 괴롭히는 행위.
              </p>
            </li>
            <li>
              <p className="text-gray-dark">
                다른 회원에 대한 개인정보를 동의 없이 수집, 저장, 공개하는 행위
              </p>
            </li>
            <li>
              <p className="text-gray-dark">
                불특정 다수를 대상으로 하여 광고 또는 선전을 게시하거나
                스팸메일을 전송하는 등의 방법으로 통합서비스를 이용하여
                영리목적의 활동을 하는 행위
              </p>
            </li>
            <li>
              <p className="text-gray-dark">
                통합서비스의 본 약관 혹은 기타 서비스 이용에 관한 규정을
                위반하는 행위
              </p>
            </li>
          </ul>
        </li>
        <li>
          <p>
            통합서비스가 제1항의 각 사유에 의해 회원의 회원자격을 상실시키기로
            결정한 경우에는 회원등록을 말소합니다. 이 경우 회원인 회원에게
            회원등록 말소 전에 이를 통지하고, 소명할 기회를 부여합니다. 다만,
            긴급성을 요하는 사안의 경우 이러한 절차를 거치지 않아도 회원자격
            상실 절차가 유효합니다.
          </p>
        </li>
        <li>
          <p>
            회원이 본 약관에 의해서 회원 가입 후 통합서비스를 이용하는 도중, 3년
            동안 통합서비스를 이용하기 위해 로그인 한 기록이 없는 경우에
            통합서비스는 회원으로 하여금 개인정보수정 요청 및 서비스 제한을 가할
            수 있습니다.
          </p>
        </li>
        <li>
          <p className="mb-2">
            회원의 공개게시물(본 약관 제12조에 정의된 바에 따름)의 내용이 다음
            각 호에 해당하는 경우 통합서비스는 회원에게 사전 통지 없이 해당
            공개게시물을 삭제할 수 있고, 해당 회원의 회원 자격을 제한, 정지 또는
            상실시킬 수 있습니다.
          </p>

          <ul className="list-decimal pl-8 flex flex-col gap-2">
            <li>
              <p className="text-gray-dark">
                다른 회원 또는 제3자를 비방하거나 중상 모략으로 명예를
                손상시키는 내용
              </p>
            </li>
            <li>
              <p className="text-gray-dark">
                공서양속에 위반되는 내용의 정보, 문장, 도형 등을 유포하는 내용.
              </p>
            </li>
            <li>
              <p className="text-gray-dark">
                범죄행위와 관련이 있다고 판단되는 내용.
              </p>
            </li>
            <li>
              <p className="text-gray-dark">
                다른 회원 또는 제3자의 지식재산권 등 기타 권리를 침해하는 내용.
              </p>
            </li>
            <li>
              <p className="text-gray-dark">
                기타 관계 법령에 위배된다고 판단되는 내용
              </p>
            </li>
            <li>
              <p className="text-gray-dark">
                종교적, 정치적 분쟁을 야기하는 내용으로서, 이러한 분쟁으로
                인하여 사이트명의 업무가 방해되거나 방해되리라고 판단되는 경우.
              </p>
            </li>
          </ul>
        </li>
        <li>
          <p>
            회원의 공개게시물로 인한 법률상 이익 침해를 근거로, 다른 회원 또는
            제3자가 회원 또는 통합서비스를 대상으로 하여 민형사상의 법적
            조치(예: 고소, 가처분신청, 손해배상청구소송 등)를 취하는 동시에 법적
            조치와 관련된 게시물의 삭제를 요청해오는 경우, 통합서비스는 동 법적
            조치의 결과(예: 검찰의 기소, 법원의 가처분결정, 손해배상판결 등)가
            있을 때까지 관련 게시물에 대한 접근을 잠정적으로 제한할 수 있습니다.
          </p>
        </li>
      </ul>

      <h5 className="font-semibold mb-4">제 8조 (회원에 대한 통지)</h5>

      <ul className="list-decimal pl-8 flex flex-col gap-3 mb-4">
        <li>
          <p>
            통합서비스가 특정 회원에 대한 통지를 하는 경우 회원이 회원 가입시
            기재한 이메일 주소, 연락처를 이용할 수 있습니다.
          </p>
        </li>
        <li>
          <p>
            통합서비스가 불특정다수 회원에 대한 통지를 하는 경우 통합서비스
            홈페이지 또는 개별 서비스 공지를 통해 사전 게시함으로써 개별 통지에
            갈음할 수 있습니다.
          </p>
        </li>
      </ul>

      <h5 className="font-semibold mb-4">제 9조 (회원의 개인정보보호)</h5>

      <ul className="list-decimal pl-8 flex flex-col gap-3 mb-4">
        <li>
          <p>
            통합서비스는 관련법령이 정하는 바에 따라서 회원 등록정보를 포함한
            회원의 개인정보를 보호하기 위하여 노력합니다. 회원의 개인정보보호에
            관해서는 관련법령 및 통합서비스가 정하는 "개인정보처리방침"에 정한
            바에 의하며, 약관과 개인정보처리방침이 상충할 경우
            개인정보처리방침이 우선합니다. 자세한 내용은 K-CDH의
            개인정보처리방침을 참고하여 주십시오.
          </p>
        </li>
      </ul>

      <h5 className="font-semibold mb-4">제 10조 (통합서비스의 의무)</h5>

      <ul className="list-decimal pl-8 flex flex-col gap-3 mb-4">
        <li>
          <p>
            통합서비스는 법령과 본 약관이 금지하거나 공서양속에 반하는 행위를
            하지 않으며, 본 약관이 정하는 바에 따라 지속적이고 안정적으로
            서비스를 제공하기 위해서 노력합니다.
          </p>
        </li>
        <li>
          <p>
            통합서비스는 회원이 안전하게 K-CDH가 제공하는 서비스를 이용할 수
            있도록 회원의 개인정보보호를 위한 보안 시스템을 구축합니다.
          </p>
        </li>
        <li>
          <p>
            통합서비스는 회원이 원하지 않는 영리목적의 광고성 전자우편을
            발송하지 않습니다.
          </p>
        </li>
      </ul>

      <h5 className="font-semibold mb-4">
        제 11조 (회원의 ID 및 비밀번호에 대한 의무)
      </h5>

      <ul className="list-decimal pl-8 flex flex-col gap-3 mb-4">
        <li>
          <p>
            통합서비스는 관계법령, K-CDH의 개인정보처리방침에 의해서 그 책임을
            지는 경우를 제외하고, 자신의 계정과 비밀번호에 관한 관리책임은 각
            회원에게 있습니다.
          </p>
        </li>
        <li>
          <p>
            회원은 자신의 계정 및 비밀번호를 제3자에게 이용하게 해서는 안됩니다.
          </p>
        </li>
        <li>
          <p>
            회원은 자신의 계정 및 비밀번호를 도난당하거나 제3자가 사용하고
            있음을 인지한 경우에는 바로 통합서비스에 통보하고 통합서비스의
            안내가 있는 경우에는 그에 따라야 합니다.
          </p>
        </li>
      </ul>

      <h5 className="font-semibold mb-4">
        제 12조 (저작권의 귀속 및 이용제한)
      </h5>

      <ul className="list-decimal pl-8 flex flex-col gap-3 mb-10">
        <li>
          <p>
            회원은 통합서비스를 이용하면서 사진, 글, (동)영상 또는 의견이나 제안
            등의 콘텐츠 (이하 게시물) 를 통합서비스 내에 게시할 수 있으며 이러한
            게시물에 대한 저작권을 포함한 지식재산권은 권리자가 계속하여
            보유합니다.
          </p>
        </li>
        <li>
          <p>
            통합서비스 중 임상연구 참여 및 기타 개별 서비스 중 게시물에 대한
            저작권을 포함한 지식재산권을 별개로 지정하고 해당 지식재산권은 회원
            본인에게 귀속되는 것으로 간주합니다.
          </p>
        </li>
        <li>
          <p>
            회원은 K-CDH에 제공한 게시물의 콘텐츠가 제3자의 지식재산권 등의
            권리를 침해해서는 안됩니다. 이러한 권리의 침해와 관련하여 발생하는
            모든 문제에 대해서는 게시자가 책임을 부담하게 되며, 이에 대한
            K-CDH의 책임은 면책 됩니다.
          </p>
        </li>
        <li>
          <p>
            회원이 통합서비스를 이용하더라도 다른 회원의 콘텐츠에 대하여 어떠한
            권리를 가지게 되는 것은 아닙니다. 회원이 다른 회원의 저작물이나
            콘텐츠 등을 사용하기 위해서는 콘텐츠 소유자로부터 별도의 허락을
            받아야 하며, 약관 등을 위반한 회원들 사이의 분쟁에 대하여 K-CDH는 그
            책임을 면합니다.
          </p>
        </li>
      </ul>

      <MyTitle title="제 4장 기타" className="mb-4" />

      <h5 className="font-semibold mb-4">제 13조 (재판관할)</h5>

      <ul className="list-disc pl-8 flex flex-col gap-3 mb-10">
        <li>
          <p>
            본 약관 또는 통합서비스는 대한민국 법령에 의하여 효력을 가지고
            대한민국 법령을 따릅니다. 통합서비스 이용과 관련하여 K-CDH와 회원
            간에 분쟁이 발생하면 이의 해결을 위해 성실히 협의할 것입니다.
            그럼에도 불구하고 해결이 되지 않으면 분쟁으로 인한 소송 기타 각종
            법적 분쟁의 관할은 서울중앙지방법원으로 합니다.
          </p>
        </li>
      </ul>

      <p>본 약관은 2024년 4월 1일부터 적용합니다.</p>
    </div>
  );
};

export default Term;
